import { useState } from 'react';
import './WaterSystemSummaryTable.css';

const WaterSystemSummaryTable = ({selectedWaterSystem}) => {
  const [expanded, setExpanded] = useState(true);

  const formatDate = (date) => {
    date = Number.parseInt(date, 10);
    if (date) {
      return new Date(date).toLocaleDateString();
    }
  }

  const waterSystemInfo = {
    activityStatus: selectedWaterSystem.activityStatus,
    alternateNum: selectedWaterSystem.alternateNum,
    email: selectedWaterSystem.adminContact?.email,
    email2: selectedWaterSystem.adminContact?.email2,
    email3: selectedWaterSystem.adminContact?.email3,
    adminFirstName: selectedWaterSystem.adminContact?.adminFirstName,
    adminLastName: selectedWaterSystem.adminContact?.adminLastName,
    adminPhone: selectedWaterSystem.adminContact?.adminPhone,
    adminPhoneExt: selectedWaterSystem.adminContact?.adminPhoneExt,
    adminEmergencyPhone: selectedWaterSystem.adminContact?.adminEmergencyPhone,
    adminEmergencyPhoneExt: selectedWaterSystem.adminContact?.adminEmergencyPhoneExt,
    county: selectedWaterSystem.county,
    countyServed: selectedWaterSystem.countyServed,
    districtNumber: selectedWaterSystem.districtNumber,
    ipsLastUpdateTs: formatDate(selectedWaterSystem?.rating?.ipsLastUpdateTs),
    indicatorName: selectedWaterSystem.indicatorName,
    lastInventoryUpdateDate: formatDate(selectedWaterSystem.lastInventoryUpdateDate),
    lastUpdateDate: formatDate(selectedWaterSystem.lastUpdateDate),
    certLevel: selectedWaterSystem.legalContact?.certLevel,
    certType: selectedWaterSystem.legalContact?.certType,
    lcAddress1: selectedWaterSystem.legalContact?.lcAddress1,
    lcAddress2: selectedWaterSystem.legalContact?.lcAddress2,
    lcCity: selectedWaterSystem.legalContact?.lcCity,
    lcFirstName: selectedWaterSystem.legalContact?.lcFirstName,
    lcState: selectedWaterSystem.legalContact?.lcState,
    lcZip: selectedWaterSystem.legalContact?.lcZip,
    lhdName: selectedWaterSystem.legalContact?.lhdName,
    operatorEndDay: selectedWaterSystem.operatingPeriod?.operatorEndDay,
    operatorEndMonth: selectedWaterSystem.operatingPeriod?.operatorEndMonth,
    operatorStartDay: selectedWaterSystem.operatingPeriod?.operatorStartDay,
    operatorStartMonth: selectedWaterSystem.operatingPeriod?.operatorStartMonth,
    phone: selectedWaterSystem.legalContact?.phone,
    population: selectedWaterSystem.population,
    rating: selectedWaterSystem.rating?.rating,
    ratingDate: formatDate(selectedWaterSystem.rating?.ratingDate),
    surveyDate: formatDate(selectedWaterSystem.lastSurvey?.surveyDate),
    surveyorFirstName: selectedWaterSystem.lastSurvey?.surveyorFirstName,
    surveyorLastName: selectedWaterSystem.lastSurvey?.surveyorLastName,
    systemId: selectedWaterSystem.systemId,
    systemName: selectedWaterSystem.systemName,
    pwsId: selectedWaterSystem.pwsId,
    systemType: selectedWaterSystem.systemType,
    totalIpsPoints: selectedWaterSystem?.rating?.totalIpsPoints,
    waterUsageAvgAnnualDemand: selectedWaterSystem.waterUsage?.avgAnnualDemand.toFixed(1),
    waterUsagecreatedDate: formatDate(selectedWaterSystem.waterUsage?.createdTs),
    waterUsageEqualizationStorage: selectedWaterSystem.waterUsage?.equalizationStorage.toFixed(1),
    waterUsagePeakDayDemand: selectedWaterSystem.waterUsage?.peakDayDemand.toFixed(1),
    zone: selectedWaterSystem.zone?.zone,
    zoneDate: selectedWaterSystem.zone?.zoneDate,
  };

  let ratingClass;
  switch (waterSystemInfo.rating) {
    case 'Approved':
      ratingClass = 'rating-approved';
      break;
    case 'Corrective Action':
      ratingClass = 'rating-correction';
      break;
    case 'Not Approved':
      ratingClass = 'rating-not-approved';
      break;
    default:
      ratingClass = 'rating-none';
      break;
  }

  const showWaterUsage = waterSystemInfo.waterUsageAvgAnnualDemand || waterSystemInfo.waterUsagePeakDayDemand || waterSystemInfo.waterUsageEqualizationStorage;
  return (
    <div className="water-system-summary-table">
      <div className="water-system-summary-header">
        <div className="water-system-name">
          <ul>
            <li className="system-name">Water System: {waterSystemInfo.systemName}</li>
            <li className="pws-id">PWS ID: {waterSystemInfo.pwsId}</li>
          </ul>
        </div>
        <div className={`water-system-rating ${ratingClass}`}>
          <ul>
            <li className="rating">Rating: {waterSystemInfo.rating}</li>
            <li>{waterSystemInfo.ratingDate}</li>
            <li className="status">Status: {waterSystemInfo.activityStatus}</li>
          </ul>
        </div>
        <button 
          className={`collapse-icon-btn ${ratingClass}`}
          onClick={() => setExpanded((prev) => !prev)}
          aria-label={expanded ? 'Collapse summary details' : 'Expand summary details'}
        >
          {expanded ? (
            <svg xmlns="http://www.w3.org/2000/svg" style={{ height: '2rem', width: '2rem' }} fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
            </svg>
          ) : (
            <svg xmlns="http://www.w3.org/2000/svg" style={{ height: '2rem', width: '2rem' }} fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
            </svg>
          )}
        </button>
      </div>
      <div className="clearfix"></div>
      <div
        className={`water-system-info-wrapper${expanded ? ' expanded' : ''}`}
      >
        <div className="water-system-info">
          <div className="col4 col4-light contacts">
            <h5>Contact Details</h5>
            <ul>
              <li><strong>Type:</strong> Admin Contact</li>
              <li><strong>Name:</strong> {waterSystemInfo.adminFirstName} {waterSystemInfo.adminLastName}</li>
              <li><strong>Office:</strong> {waterSystemInfo.adminPhone}</li>
              <li><strong>Emergency:</strong> {waterSystemInfo.adminEmergencyPhone}</li>
              <li><strong>Email:</strong> <br />{waterSystemInfo.email}<br />{waterSystemInfo.email2}<br />{waterSystemInfo.email3}</li>
            </ul>
          </div>
          <div className="col4 col4-dark site-info">
            <h5>Site Information</h5>
            <ul>
              <li><strong>Legal Contact:</strong> {waterSystemInfo.lcFirstName}</li>
              <li>
                <strong>Address:</strong> {waterSystemInfo.lcAddress1} {waterSystemInfo.lcAddress2}<br></br>
                {waterSystemInfo.lcCity}, {waterSystemInfo.lcState} {waterSystemInfo.lcZip}
              </li>
              <li><strong>Phone:</strong> {waterSystemInfo.phone}</li>
              <li><strong>County:</strong> {waterSystemInfo.countyServed}</li>
              <li><strong>System Type:</strong> {waterSystemInfo.systemType}</li>
              <li><strong>Certification Required:</strong> {waterSystemInfo.certType}</li>
              <li><strong>Total Population:</strong> {waterSystemInfo.population}</li>
              <li><strong>Local Health District:</strong> {waterSystemInfo.lhdName}</li>
            </ul>
          </div>
          <div className="col4 col4-light site-updates">
            <h5>Site Updates</h5>
            <ul>
              <li><strong>Last Inventory Update:</strong> {waterSystemInfo.lastInventoryUpdateDate}</li>
              <li><strong>Last Surveyor Update:</strong> {waterSystemInfo.surveyDate}</li>
              <li><strong>Surveyor:</strong> {waterSystemInfo.surveyorFirstName} {waterSystemInfo.surveyorLastName}</li>
              <li><strong>Operating Period:</strong> {waterSystemInfo.operatorStartMonth}/{waterSystemInfo.operatorStartDay} - {waterSystemInfo.operatorEndMonth}/{waterSystemInfo.operatorEndDay}</li>
              <li><strong>Last IPS Update:</strong> {waterSystemInfo.ipsLastUpdateTs}</li>
            </ul>
          </div>
          <div className="col4 col4-dark political-districts">
            <h5>Political Districts</h5>
            <ul>
              <li><a href="https://le.utah.gov/GIS/findDistrict.jsp">Legislative District Map</a></li>
              <li>&nbsp;</li>
              <li><strong>Water Usage Information per ERC</strong></li>
              {showWaterUsage && (
                <>
                  <li>Standard as of: {waterSystemInfo.waterUsagecreatedDate}</li>
                  <li>Peak Day Demand per ERC (gal/ERC): {waterSystemInfo.waterUsagePeakDayDemand}</li>
                  <li>Average Annual Demand per ERC (gal/ERC): {waterSystemInfo.waterUsageAvgAnnualDemand}</li>
                  <li>Equalization Storage per ERC (gal/ERC): {waterSystemInfo.waterUsageEqualizationStorage}</li>
                </>
              )}
              <li>Total IPS Points: {waterSystemInfo.totalIpsPoints}</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
}
export default WaterSystemSummaryTable;